import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import MailIcon from '@mui/icons-material/Mail';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import { ContatoPage, ContatoBox } from 'src/styles/styledComponents';
import { getWhatsAppUrl } from 'src/utils';
import { useAppSelector } from 'src/app/hooks';

export default function Contato() {
  const isMobile = useAppSelector((status) => status.page.isMobile);
  return (
    <ContatoPage>
      <ContatoBox>
        <WhatsAppIcon />
        <Box>
          <Typography variant="h6">Telefone</Typography>
          <Typography variant="h5">
            <a
              style={{ color: '#fff' }}
              href={getWhatsAppUrl({ phoneNumber: '63981154678', isMobile })}
              target="_blank"
              rel="noreferrer">
              (63) 98115-4678
            </a>
          </Typography>
        </Box>
      </ContatoBox>
      <Divider />
      <ContatoBox>
        <MailIcon />
        <Box>
          <Typography variant="h6">E-mail</Typography>
          <Typography variant="h5">
            <a style={{ color: '#fff' }} href="mailto:asmubip@gmail.com">
              asmubip@gmail.com
            </a>
          </Typography>
        </Box>
      </ContatoBox>
      <Divider />
      <ContatoBox>
        <LocationOnIcon />
        <Box>
          <Typography variant="h6">Endereço</Typography>
          <Typography variant="h5">
            Avenida Santos Dumont, SN - Vila Barreto, São Miguel do Tocantins - TO
          </Typography>
          <Typography variant="h5">CEP: 77.925-000</Typography>
        </Box>
      </ContatoBox>
      <Divider />
      <ContatoBox>
        <InstagramIcon />
        <Box>
          <Typography variant="h6">Instagram</Typography>
          <Typography variant="h5">
            <a
              style={{ color: '#fff' }}
              href="https://www.instagram.com/asmubip"
              target="_blank"
              rel="noopener noreferrer">
              @asmubip
            </a>
          </Typography>
        </Box>
      </ContatoBox>
      <Divider />
      <ContatoBox>
        <FacebookIcon />
        <Box>
          <Typography variant="h6">Facebook</Typography>
          <Typography variant="h5">
            <a
              style={{ color: '#fff' }}
              href="https://www.facebook.com/61575189737488"
              target="_blank"
              rel="noopener noreferrer">
              AsmubipTO
            </a>
          </Typography>
        </Box>
      </ContatoBox>
    </ContatoPage>
  );
}
